import request from "@/lib/api/handler";
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "../utils";
import { AdminPayout } from "@/types";

export const useAdminPayoutsQuery = () => {
  const { getAccessTokenSilently } = useAuth0();
  const {
    data: adminPayouts,
    error: adminPayoutsError,
    isLoading: adminPayoutsLoading,
  } = useQuery({
    queryKey: QueryKeys.adminPayouts,
    enabled: true,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    async queryFn() {
      const token = await getAccessTokenSilently();
      return await request<AdminPayout[]>({
        method: "GET",
        path: "/api/admin/payouts",
        token,
      });
    },
  });

  return {
    adminPayouts,
    adminPayoutsError,
    adminPayoutsLoading,
  };
};
